import { useState, useEffect } from "react";
import { showAlert } from "../components/Helpers/Utils";

const clientFunc = () => {
  const formData = new FormData(document.getElementById("frmCreateClient"));
  createClient(formData)
    .then((data) => {
      showAlert(data, "success");
    })
    .catch((error) => {
      console.log(error);
    });
};

const createClient = async (formDt) => {
  const url = "https://www.innovations.co.ke/portalapi/public/api/createClient";
  const options = {
    method: "POST",
    body: formDt,
  };
  const response = await fetch(url, options);
  if (response.status !== 200) {
    throw new Error("There was an error creating Client :" + response.status);
  }
  const data = await response.json();
  return data;
};
//COMPONENT
const ClientCreate = () => {
  const [loadedType, setLoadedType] = useState([]);

  useEffect(() => {
    viewTypes()
      .then((data) => {
        setLoadedType(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const viewTypes = async () => {
    const response = await fetch("https://www.innovations.co.ke/portalapi/public/api/viewType");
    if (response.status !== 200) {
      throw new Error("There was an error creating Admin :" + response.status);
    }
    const data = await response.json();
    return data;
  };

  return (
    <div className="card col-md-4 mx-auto" style={{ marginTop: "20%" }}>
      <div className="card-header text-center bg-white">
        <h1>
          <span className="text-danger fw-bolder">Create </span>
          <span className="text-info fst-italic">Client</span>
        </h1>
      </div>
      <div className="card-body">
        <form
          id="frmCreateClient"
          className="d-grid gap-3"
          encType="multipart/form-data"
        >
          <div className="form-group">
            <label htmlFor="password">Name</label>
            <input
              type="text"
              className="form-control"
              autoComplete="off"
              id="name"
              name="name"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="type">Type</label>
            <select className="form-select" id="type" name="type">
              <option value="">Select Type</option>
              {loadedType.map((dt) => {
                return (
                  <option key={dt.type_id} value={dt.type_id}>
                    {dt.type}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="password">Logo</label>
            <input
              type="file"
              className="form-control"
              autoComplete="off"
              id="fileToUpload"
              name="fileToUpload"
              accept="image/*"
              required
            />
          </div>
          <button
            type="button"
            id="btnClient"
            onClick={clientFunc}
            className="btn btn-secondary mx-auto fs-5"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ClientCreate;
